import { useQuery } from '@tanstack/react-query'
import getFarmFilterOptions from '../../services/ruutsApi/v2/farms/getFarmFilterOptions'
import { queryKeys } from './queryKeys'

// Not Infinity like refData: programs and hubs can be added at any time.
export const useFarmFilterOptions = (options?: { enabled?: boolean }) =>
  useQuery({
    queryKey: queryKeys.farmFilterOptions(),
    queryFn: ({ signal }) => getFarmFilterOptions({ signal }),
    staleTime: 5 * 60_000,
    enabled: options?.enabled ?? true,
  })
